import OrganizationUserApi from '@/api/OrganizationUserApi';
import UserApi from '@/api/UserApi';
import { i18n } from '@/i18n';
import { Bus, useAside, useNotif } from '@orion.ui/orion';
import { defineAsyncComponent } from 'vue';

class OrganizationUserService implements ResourceService {

	async storeAsync (payload: IAddOrganizationUserModel) {
		await OrganizationUserApi.add(payload);
		Bus.emit('OrganizationUserPagedListViewSetup:refreshList', true);
	}

	async getAsync (/* id: number */) {
		throw new Error('Method not implemented.');
	}

	async gridAsync (...args: Parameters<typeof OrganizationUserApi.grid>) {
		const { data } = await OrganizationUserApi.grid(...args);
		return data;
	}

	async updateAsync (/* id: number, payload: any */) {
		throw new Error('Method not implemented.');
	}

	async deleteAsync (id: number) {
		try {
			await OrganizationUserApi.delete(id);
			useNotif.success(i18n.global.t('user.userDeletedSuccessfully'));
			Bus.emit('OrganizationUserPagedListViewSetup:refreshList');
		}
		catch (error: any) {
			useNotif.danger(error?.response?.data);
		}
	}

	async sendActivationMailAsync (userId: number) {
		try {
			await UserApi.sendEmailActivation(userId);
			useNotif.success(i18n.global.t('common.emailSentSuccessfully'));
		}
		catch (error) {
			useNotif.danger(i18n.global.t('user.oopsThereWasAProblem'));
		}
	}

	async promptNewOrganizationUserAsync () {
		useAside({ Nested: defineAsyncComponent(() => import('@/components/organization-user/OrganizationUserAsideNew.vue')) });
	}

	async selectByIdAsync (...args: Parameters<typeof OrganizationUserApi.selectById>) {
		const { data } = await OrganizationUserApi.selectById(...args);
		return data;
	}

}

export function useOrganizationUserService () {
	return new OrganizationUserService();
}
